/*
 * Layout Name: Category Grid
 * Desc:
 */
import { useScrollPosition } from "@n8tb1t/use-scroll-position"
import React, { useState } from "react"
import * as styles from "./ScrollMenu.module.scss"

const ScrollMenu = ({ children, title, className = "" }) => {
  const [showMenu, setShowMenu] = useState(false)
  const [expandedMenu, setExpandedMenu] = useState(false)
  const [menuStyle, setMenuStyle] = useState("")
  const [closeMenuTimer, setCloseMenuTimer] = useState()

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y < -300
      if (isShow !== showMenu) {
        setShowMenu(isShow)
      }
      setMenuStyle(isShow ? styles.minimized : "")
      setExpandedMenu(false)
    },
    [showMenu]
  )

  const handleMouseEnter = () => {
    clearTimeout(closeMenuTimer)
    setMenuStyle(styles.full)
    setExpandedMenu(true)
  }

  const handleMouseLeave = () => {
    const timer = setTimeout(() => {
      setMenuStyle(showMenu ? styles.minimized : "")
      setExpandedMenu(false)
    }, 1000)
    setCloseMenuTimer(timer)
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`${styles.ScrollMenu} ${menuStyle} ${className}`}
    >
      <div className={`${styles.title} ${styles.fadeIn} ${expandedMenu ? "" : styles.active}`}>
        <span>{title}</span>
      </div>
      <div className={`${styles.fadeIn} ${expandedMenu ? styles.active : ""}`}>{children}</div>
    </div>
  )
}

export default ScrollMenu
